import { createRoot, hydrateRoot } from "react-dom/client";
import Root from "./Root";
import { preloadPublicPage } from "./public-pages";
import "./index.css";

const root = document.getElementById("root")!;
async function mount() {
  if (root.dataset.prerendered === "true") {
    // A session response must not update a still-hydrating lazy boundary.
    // Keep the prerendered content visible while its own page chunk loads.
    await preloadPublicPage(window.location.pathname);
    hydrateRoot(root, <Root />);
  } else {
    createRoot(root).render(<Root />);
  }
}
void mount();
